// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__gt8lf","itemTitle":"ClientEmergencyInfo_itemTitle__3sgma","itemText":"ClientEmergencyInfo_itemText__2YV3p"};